<template>
  <!-- This component renders nothing -->
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'CommonBreadCrumbSchemaComponent',
  data() {
      return {
        webUrl: process.env.VUE_APP_URL,
      }
  },
  mounted() {
    const oldScript = document.getElementById('common-breadcrumb-schema');
    if (oldScript) oldScript.remove();

    const BreadcrumbSchema = document.createElement('script');
    BreadcrumbSchema.setAttribute('type', 'application/ld+json');
    BreadcrumbSchema.setAttribute('id', 'common-breadcrumb-schema');

    const baseUrl = this.webUrl.replace(/\/$/, '');

    // current route name
    const currentRouteName = this.$route.name || '';

    // Map route names to breadcrumb display names and positions
    const breadcrumbConfig = {
      'home': { name: 'Home', position: 1 },               
      'allDailyPaidJoblisting': { name: 'Part Time Jobs Singapore', position: 2 },
      'allJobsListing': { name: 'Full Time Jobs Singapore', position: 3 },
      'ResumeBuilder': { name: 'Resume Builder', position: 4 },
      'employer2': { name: 'Employer', position: 5 },
      'blog': { name: 'Blog', position: 6 },
      // Add more route names as needed
    };

    // Always add Home breadcrumb first
    const breadcrumbItems = [];

    if (breadcrumbConfig['home']) {
      breadcrumbItems.push({
        name: breadcrumbConfig['home'].name,
        url: baseUrl,
        position: breadcrumbConfig['home'].position
      });
    }

    // Add current page breadcrumb if route name exists in config and is not home
    if (currentRouteName && currentRouteName !== 'home' && breadcrumbConfig[currentRouteName]) {
      breadcrumbItems.push({
        name: breadcrumbConfig[currentRouteName].name,
        url: this.webUrl + this.$route.path.replace(/^\/+/, ''), // full current URL
        position: breadcrumbConfig[currentRouteName].position
      });
    }

    // Map items to schema.org ListItem format
    // const itemList = breadcrumbItems.map(item => ({
    //   "@type": "ListItem",
    //   position: item.position,
    //   name: item.name,
    //   item: item.url
    // }));

    const itemList = breadcrumbItems.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1, // <- sequential: 1, 2
      name: item.name,
      item: item.url
    }));

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: itemList
    };

    BreadcrumbSchema.text = JSON.stringify(schema, null, 2);
    document.head.appendChild(BreadcrumbSchema);
  }
};
</script>
